module.exports = __webpack_public_path__ + "img/ktzy-white.cb859ecb.png";